export const LIST = 'List';
//# sourceMappingURL=LIST.js.map